import { TENANTS } from '@topconagriculture/theme';

import * as packageJson from '../../../package.json';

export enum NodeEnvEnum {
  development = 'development',
  production = 'production',
  test = 'test',
}

let config: any = {
  APP_NAME: process.env.REACT_APP_APP_TITLE,
  APP_TITLE: process.env.REACT_APP_APP_TITLE,
  NODE_ENV: (process.env.REACT_APP_NODE_ENV as NodeEnvEnum) || NodeEnvEnum.development,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  APP_ID: process.env.REACT_APP_APP_ID || '5ea01123a74e10da5fa35e82',
  PROFILE_MANAGER_API_BASE_URL: process.env.REACT_APP_PROFILE_MANAGER_API_BASE_URL,
  SUBSCRIPTIONS_API_BASE_URL: process.env.REACT_APP_SUBSCRIPTIONS_API_BASE_URL,
  RELEASE_VERSION: packageJson.version,
  RESOURCES_BASE_URL: process.env.REACT_APP_RESOURCES_BASE_URL,
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
  AUTH0_CALLBACK_URL: process.env.REACT_APP_AUTH0_CALLBACK_URL,
  AUTH0_SILENT_URL: process.env.REACT_APP_AUTH0_SILENT_URL,
  AUTH0_SCOPE: process.env.REACT_APP_AUTH0_SCOPE,
  AUTH0_REDIRECT_URI: process.env.REACT_APP_AUTH0_REDIRECT_URI,
  AUTH0_LOGOUT_RETURN_URL: process.env.REACT_APP_AUTH0_LOGOUT_RETURN_URL,
  MYGAMETE_SETTING_URL: process.env.REACT_APP_MYGAMETE_SETTING_URL,
  BUGMUNCHER_ID: process.env.REACT_APP_BUGMUNCHER_ID,
  GRECAPTCHA_API_KEY: process.env.REACT_APP_GRECAPTCHA_API_KEY,
  RECAPTCHA_SCRIPT_URL: process.env.REACT_APP_RECAPTCHA_SCRIPT_URL,
  NOTIFICATIONS_HOSTNAME: process.env.REACT_APP_NOTIFICATIONS_HOSTNAME,
  NOTIFICATION_SUBSCRIPTION_PATH: process.env.REACT_APP_NOTIFICATION_SUBSCRIPTION_PATH,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  GOOGLE_PLAY_URL: process.env.REACT_APP_GOOGLE_PLAY_URL,
  APP_STORE_URL: process.env.REACT_APP_APP_STORE_URL,
  SERVICE_AGREEMENTS_URL: process.env.REACT_APP_SERVICE_AGREEMENTS_URL,
  POLICIES_URL: process.env.REACT_APP_POLICIES_URL,
  GET_HELP_URL: process.env.REACT_APP_GET_HELP_URL,
  MARKETPLACE_URL: process.env.REACT_APP_MARKETPALCE_URL,
  GRAPHLQ_CLIENT_BASE_URL: process.env.REACT_APP_GRAPHLQ_CLIENT_BASE_URL,
  SERVICE_AGREEMENTS_REDIRECT_URL: process.env.REACT_APP_SERVICE_AGREEMENTS_REDIRECT_URL,
  STORAGE_API_BASE_URL: process.env.REACT_APP_STORAGE_API_BASE_URL,
  FLEET_GRAPHQL_WSS_CLIENT_BASE_URL: process.env.REACT_APP_FLEET_GRAPHQL_WSS_CLIENT_BASE_URL,

  FEED_SUBSCRIPTION_SKUS: process.env.REACT_APP_FEED_SUBSCRIPTION_SKUS,

  TENANT_ID: process.env.REACT_APP_TENANT_ID! as TENANTS,
  TENANT_NAME: process.env.REACT_APP_TENANT_NAME!,
  TENANT_RESOURCES_BASE_URL: `${process.env.REACT_APP_RESOURCES_BASE_URL}/${process.env.REACT_APP_TENANT_NAME}`,

  PLATFORM_NOTIFICATIONS_STORAGE_URL: process.env.REACT_APP_PLATFORM_NOTIFICATIONS_STORAGE_URL!,
  PLATFORM_NOTIFICATIONS_STORAGE_CONTAINER: process.env.REACT_APP_PLATFORM_NOTIFICATIONS_STORAGE_CONTAINER!,
  PLATFORM_NOTIFICATIONS_SAS_TOKEN: process.env.REACT_APP_PLATFORM_NOTIFICATIONS_SAS_TOKEN!,

  ALARMS_VIEW_MORE_LINK: process.env.REACT_APP_ALARMS_VIEW_MORE_LINK,
  API_BASE_URL_DEFAULT: process.env.REACT_APP_API_BASE_URL_DEFAULT,
  API_BASE_URL_FIELDS: process.env.REACT_APP_API_BASE_URL_FIELDS,
  FIELDS_APP_ID: process.env.REACT_APP_FIELDS_APP_ID,
  FLEET_APP_ID: process.env.REACT_APP_FLEET_APP_ID,
  GOOGLE_MAP_API_KEY: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  GOOGLE_MAP_VERSION: process.env.REACT_APP_GOOGLE_MAP_VERSION,
  MACHINE_STATUS_VIEW_MORE_LINK: process.env.REACT_APP_MACHINE_STATUS_VIEW_MORE_LINK,
  MAP_VIEW_MORE_LINK: process.env.REACT_APP_MAP_VIEW_MORE_LINK,
  MARKET_APP_ID: process.env.REACT_APP_MARKET_APP_ID,
  STORAGE_APP_ID: process.env.REACT_APP_STORAGE_APP_ID,
  SUPPORT_APP_ID: process.env.REACT_APP_SUPPORT_APP_ID,
  TASKS_VIEW_MORE_LINK: process.env.REACT_APP_TASKS_VIEW_MORE_LINK,
  FEED_VIEW_MORE_LINK: process.env.REACT_APP_FEED_VIEW_MORE_LINK,
  FEED_URL: process.env.REACT_APP_FEED_URL,
  DISABLE_DATA_EXPORT: process.env.REACT_APP_DISABLE_DATA_EXPORT === 'true' || false,
  SERVICE_WORKER_ENABLED: process.env.REACT_APP_SERVICE_WORKER_ENABLED,
};

/**
 * Search for an app_env object. This case can only accour in production, where build pipelines
 * populate app_env.js (you can find it inside src directory) with env variables.
 */

const productionEnvVars = (window as any).app_env;
if (productionEnvVars) {
  config = {
    ...config,
    ...productionEnvVars,
  };
}

config.TENANT_RESOURCES_BASE_URL = `${config.RESOURCES_BASE_URL}/${config.TENANT_NAME}`;

//
// !!! WARNING !!!
//
// ONLY FROM HERE ON config CONTAINS REAL APP_ENV VARS VALUES!
// i.e. the one read from the browser, at final's user runtime
//

if (process.env.NODE_ENV !== NodeEnvEnum.test) {
  if (!config.TENANT_ID) {
    throw new Error('Please set a tenant id');
  }

  if (!config.TENANT_NAME) {
    throw new Error('Please set a tenant name');
  }
}

// Dump config, for easier troubleshooting
if (config.NODE_ENV === 'development') {
  // tslint:disable-next-line
  console.table(config);
  // console.log('config: ' + JSON.stringify(config));
}

export default config;
